import React, { useState } from 'react';
import type { ToastContextType } from '@/types/components/common/toast';
import { ToastContext } from './context';
import { ToastContainer } from './ToastContainer';

interface ToastProviderProps {
    children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
    const [contextValue] = useState<ToastContextType>({
        addToast: () => {},
        removeToast: () => {}
    });

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            <ToastContainer />
        </ToastContext.Provider>
    );
};